export default [
  {
    label: 'Gengenpress',
    imageUrl: '/GuildBall/game-plans/gengenpress.png',
    initiative: 7,
    influence: -1,
  },
  {
    label: 'Brown Envelope',
    imageUrl: '/GuildBall/game-plans/brown_envelope.png',
    initiative: 7,
    influence: 0,
  },
  {
    label: 'Rushed Back',
    imageUrl: '/GuildBall/game-plans/rushed_back.png',
    initiative: 6,
    influence: 0,
  },
  {
    label: 'What A Strike!',
    imageUrl: '/GuildBall/game-plans/what_a_strike.png',
    initiative: 6,
    influence: 0,
  },
  {
    label: 'Catenaccio',
    imageUrl: '/GuildBall/game-plans/catenaccio.png',
    initiative: 5,
    influence: 0,
  },
  {
    label: 'Nowhere To Hide',
    imageUrl: '/GuildBall/game-plans/nowhere_to_hide.png',
    initiative: 5,
    influence: 0,
  },
  {
    label: 'Adrenaline Rush',
    imageUrl: '/GuildBall/game-plans/adrenaline_rush.png',
    initiative: 4,
    influence: 0,
  },
  {
    label: 'Big Rivals',
    imageUrl: '/GuildBall/game-plans/big_rivals.png',
    initiative: 4,
    influence: 0,
  },
  {
    label: 'Man Marking',
    imageUrl: '/GuildBall/game-plans/man_marking.png',
    initiative: 4,
    influence: 0,
  },
  {
    label: 'Match Fixing',
    imageUrl: '/GuildBall/game-plans/match_fixing.png',
    initiative: 4,
    influence: 0,
  },
  {
    label: 'No Guts, No Glory',
    imageUrl: '/GuildBall/game-plans/no_guts_no_glory.png',
    initiative: 4,
    influence: 2,
  },
  {
    label: 'High Press',
    imageUrl: '/GuildBall/game-plans/high_press.png',
    initiative: 3,
    influence: 0,
  },
  {
    label: 'Lost Focus',
    imageUrl: '/GuildBall/game-plans/lost_focus.png',
    initiative: 3,
    influence: 0,
  },
  {
    label: 'Home Advantage',
    imageUrl: '/GuildBall/game-plans/home_advantage.png',
    initiative: 3,
    influence: 1,
  },
  {
    label: 'Pep Talk',
    imageUrl: '/GuildBall/game-plans/pep_talk.png',
    initiative: 2,
    influence: -1,
  },
  {
    label: 'Set Me Up',
    imageUrl: '/GuildBall/game-plans/set_me_up.png',
    initiative: 2,
    influence: 1,
  },
  {
    label: 'Feign Injury',
    imageUrl: '/GuildBall/game-plans/feign_injury.png',
    initiative: 1,
    influence: 0,
  },
  {
    label: 'Extra Shot',
    imageUrl: '/GuildBall/game-plans/extra_shot.png',
    initiative: 1,
    influence: 0,
  },
];
